/**
 * Subtítulo del beat en curso: una píldora abajo, como en un video.
 */
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';

export function Subtitles({ text }: { text: string | null }) {
  const reduce = useReducedMotion();
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-7 z-203 flex justify-center px-4">
      <AnimatePresence mode="wait">
        {text && (
          <motion.p
            key={text}
            className="max-w-3xl rounded-2xl bg-[#0b1513]/90 px-5 py-3 text-center text-[17px] leading-snug text-white shadow-[0_12px_40px_rgba(0,0,0,0.35)] backdrop-blur-sm"
            style={{ textWrap: 'balance' }}
            initial={reduce ? false : { opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 4 }}
            transition={{ duration: 0.18 }}
          >
            {text}
          </motion.p>
        )}
      </AnimatePresence>
    </div>
  );
}
